/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import CustomModal from "../../../../../components/Modal/CustomModal";
import CustomWarningLegend from "../../../../../components/CustomWarningLegend";
import CopyEventLinkApp from "../Functionality/CopyEventLinkApp";

const CopyEventLinkModal = ({
    show,
    setShow,
    itemSelected,
    setItemSelected,
    setSelectedList
}) => {
    const {
        t,
        buttonText,
        handleConfirm,
        link,
        onHideModal
    } = CopyEventLinkApp({
        show,
        setShow,
        itemSelected,
        setItemSelected,
        setSelectedList
    });


    return (<>
            <CustomModal
                show={show}
                title={"reservation_link"}
                size="lg"
                cancelButton={false}
                closeButton={false}
                confirmButton={true}
                disabled={false}
                onConfirm={handleConfirm}
                buttonConfirm={buttonText}
                onHide={onHideModal}
                classNameBody="pt-2"
            >
                <div className={"row"}>
                    <div className={"col-12 center-text"}>
                        <p className={"font-color-general-950 fs-14px"}>{t("unique_link_gives_the_guest_direct_access_to_their_reservation")}</p>
                        <p className={"font-color-general-950 fs-14px"}>{t("by_opening_it_the_guest_can_complete_their_registration_reservation")}</p>
                    </div>

                    <div className={"col-12 center-text"}>
                        <p className={"font-color-general-950 ibl-font-w-600 text-uppercase fs-14px"}>{t("warning")}: {t("it_must_not_be_shared_with_unauthorized_individuals")}</p>
                    </div>
                    <div className={"col-12 center-text"}>
                        <p className={"font-color-general-950 ibl-font-w-600 text-uppercase fs-14px"}>{t("please_copy_the_reservation_link_to_continue")}</p>
                    </div>
                    <div className={"col-12"}>
                        <CustomWarningLegend>{link}</CustomWarningLegend>
                    </div>
                </div>
            </CustomModal>
    </>

    );
};

export default CopyEventLinkModal;
